import React from "react";
import { useNavigate } from "react-router-dom";
import Wordmark from "../images/TrattoriaDemiCenteredWhite.png";
import FancyLine from "../images/Gold under.webp";
import Vases from "../images/VasesDarker.png";

const MAPS_URL =
  "https://www.google.com/maps/place/Trattoria+Demi/@42.0462027,-87.6841271,17z/data=!3m1!4b1!4m6!3m5!1s0x880fd00d95d69657:0xda4a27ea17ff42a1!8m2!3d42.0461987!4d-87.6815522!16s%2Fg%2F1th7yynq?entry=ttu";

export function Footer() {
  const navigate = useNavigate();

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return (
    <footer className="site-footer">
      <div className="sf-row sf-top">
        <div className="sf-block sf-hours">
          <p className="sf-hours-note">
            Open seven days a week for lunch and dinner.
          </p>
          <p>
            Mon &ndash; Thurs <span>11:30am &ndash; 8:30pm</span>
          </p>
          <p>
            Fri &ndash; Sat <span>11:30am &ndash; 9:30pm</span>
          </p>
          <p>
            Sunday <span>12:00pm &ndash; 8:30pm</span>
          </p>
        </div>

        <div className="sf-top-right">
          <div className="sf-block sf-right-align">
            <button className="sf-link" onClick={() => navigate("/menu")}>
              menu
            </button>
            <button className="sf-link" onClick={() => navigate("/reserve")}>
              reserve
            </button>
            <button className="sf-link" onClick={() => navigate("/order")}>
              order
            </button>
          </div>
          <div className="sf-block sf-right-align">
            <button className="sf-link" onClick={() => navigate("/gallery")}>
              gallery
            </button>
            <button className="sf-link" onClick={() => navigate("/giftcards")}>
              gift cards
            </button>
            <button className="sf-link" onClick={() => navigate("/FAQ")}>
              FAQ
            </button>
            <button className="sf-link" onClick={() => navigate("/contact")}>
              contact
            </button>
          </div>
        </div>
      </div>

      <div className="sf-mark">
        <img
          className="sf-wordmark"
          src={Wordmark}
          alt="Trattoria Demi"
          loading="lazy"
        />
        <img className="sf-fancy-line" src={FancyLine} alt="" loading="lazy" />
      </div>

      <div className="sf-row sf-bottom">
        <div className="sf-block">
          <a className="sf-link" href="tel:847-332-2330">
            847-332-2330
          </a>
          <a className="sf-link" href="mailto:trattoriademi@gmail.com">
            trattoriademi@gmail.com
          </a>
          <button className="sf-link" onClick={() => openInNewTab(MAPS_URL)}>
            1571 Sherman Ave, Evanston, IL 60201
          </button>
        </div>

        <div className="sf-script">since 1993</div>

        <img
          className="sf-vases"
          src={Vases}
          alt=""
          aria-hidden="true"
          loading="lazy"
        />
      </div>

      {/* Mobile-only: the script pins the bottom edge while the sections
          above it reorder (wordmark, contact, hours). */}
      <div className="sf-script sf-script-mobile">since 1993</div>
    </footer>
  );
}
